import { RoomTypeID } from '@kamernet/core/ApiClient/Kamernet';

const LISTING_TYPE_TO_STRING: Record<RoomTypeID, string> = {
  [RoomTypeID.Room]: 'Room',
  [RoomTypeID.Apartment]: 'Appartement',
  [RoomTypeID.Studio]: 'Studio',
  [RoomTypeID.Antikraak]: 'Antikraak',
  [RoomTypeID.StudentResidence]: 'StudentHousing',
};

export function getReplyConversationEventPayload({
  listingID,
  listingCity,
  listingType,
  isAutoReply,
  conversationID,
  isCurrentUserLandlord,
  otherParticipantUserID,
  currentUserID,
}: {
  listingID: number | undefined;
  listingCity: string | undefined;
  listingType: RoomTypeID | undefined;
  isAutoReply: boolean;
  conversationID: number;
  isCurrentUserLandlord: boolean;
  otherParticipantUserID: number;
  currentUserID: string;
}): {
  advert_city: string;
  advert_id: string;
  advert_type: string;
  advertiserid: string;
  autoreply: string;
  conid: string;
  messageSource: string;
  role: string;
  tenantid: string;
} {
  const landlordUserID = isCurrentUserLandlord
    ? currentUserID.toString()
    : otherParticipantUserID.toString();

  const tenantUserID = isCurrentUserLandlord
    ? otherParticipantUserID.toString()
    : currentUserID.toString();

  return {
    advert_id: listingID?.toString() || '',
    advert_city: listingCity || '',
    advert_type: listingType ? LISTING_TYPE_TO_STRING[listingType] : '',
    advertiserid: landlordUserID.toString(),
    autoreply: isAutoReply.toString(),
    conid: conversationID.toString(),
    messageSource: 'Messages',
    role: isCurrentUserLandlord ? 'Landlord' : 'Tenant',
    tenantid: tenantUserID.toString(),
  };
}
